import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { CoverageRequestsPage } from "@/features/coverage-requests";
import { useSwitchToLinkedAccount } from "@/features/auth/hooks/useSwitchToLinkedAccount";

const searchSchema = z.object({
  requestId: z.coerce.number().optional(),
  account: z.coerce.number().int().positive().optional(),
});

function CoverageRequestsRoute() {
  const search = Route.useSearch();
  const switchingAccount = useSwitchToLinkedAccount(search.account);

  if (switchingAccount) return null;

  return <CoverageRequestsPage initialRequestId={search.requestId} />;
}

export const Route = createFileRoute("/coverage-requests/")({
  component: CoverageRequestsRoute,
  staticData: { authorize: true },
  validateSearch: searchSchema,
});
